<template>
  <div class="animated fadeIn step-container">
  
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2 v-if="$route.query.action === 'edit'">{{$t('message.doctor_header.title_edit')}}</h2>
        <h2 v-else>{{$t('message.doctor_header.title_new')}}</h2>
        <step :currentStep="3" :maxStep="5" @step_clicked='gotoPage'>
          <div slot='1'>{{$t('message.doctor_header.personal_info')}}</div>
          <div slot='2'>{{$t('message.doctor_header.experience')}}</div>
          <div slot='3'>{{$t('message.doctor_header.schedules')}}</div>
          <div slot='4'>{{$t('message.doctor_header.education')}}</div>
          <div slot='5'>{{$t('message.doctor_header.other_info')}}</div>
        </step>
      </div>
      <div class="col-md-8 offset-md-2 step-body">
        <h4 class="step-header">{{$t('message.doctor_schedules.schedule')}}</h4>

        <div class="row">
          <div class="col-12">
            <div class="form-group online-appointment" :class="{ 'disable': !$guser.isPremiumAccount() }" v-on:click="checkFeature()">
              
              <label class="switch switch-text switch-pill switch-success">
                <input type="checkbox" class="switch-input" v-model="doctor.appointment_active" :disabled="!$guser.isPremiumAccount()" >
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
              <label for="name" class="switch-name">{{$t('message.doctor_schedules.online_appointment_on')}} <i class="fa fa-lock menu-lock" aria-hidden="true" v-if="!$guser.isPremiumAccount()"></i></label>

            </div>
          </div>
        </div>

        <div class="row" v-for="clinic in doctor.clinics" :key="clinic.id">
          <div class="col-12" v-if="shouldView(clinic.id)">
            <div class="form-group">
              <label for="name">{{$t('message.doctor_schedules.select_time_slot_for')}} <b>{{ ($i18n.locale === 'th') ? clinic.name_th : clinic.name_en }}</b></label>
            </div>
            <working-schedule :schedules="schedules_by_clinics[clinic.id]" 
                              :doctor_id="doctor.id"
                              :clinic_id="clinic.id" 
                              :booking_per_slot="slotData[clinic.id].booking_per_slot"
                              :time_slots="slotData[clinic.id].time_slots"
                              :advance_week_option="true"
                              @scheduleChanged="updateSchedules"/>

          <working-time-slot :time_slots="slotData[clinic.id].time_slots"
                            :clinic_id="clinic.id" 
                            :doctor_id="doctor.id"
                            @timeSlotsChanged="updateTimeSlots"/>

          <working-booking-per-slot :booking_per_slot="slotData[clinic.id].booking_per_slot"
                            :clinic_id="clinic.id" 
                            :doctor_id="doctor.id"
                            @bookingPerSlotChanged="updateBookingPerSlot"/>
          <working-slot-preview :booking_per_slot="slotData[clinic.id].booking_per_slot"
                            :time_slots="slotData[clinic.id].time_slots"/>
          </div>
        </div>

        <div class="row">
          <div class="col-12 form-group">
            <button class="btn btn-cancel btn-lg" @click="back">{{$t('action_message.back')}}</button>
            <button class="btn btn-store btn-lg" @click="saveAndContinue">{{$t('action_message.save')}}</button>
            <button v-if="$route.query.action === 'edit'" class="btn btn-delete btn-right btn-lg" @click="deleteDoctor">{{$t('action_message.remove')}}</button>
          </div>
        </div>

      </div>

      <sweet-modal icon="info" title="ฟังชั้นนี้ถูกปิดการใช้งานอยู่" ref="lockModal" overlay-theme="dark">
        <p>ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง</p>
        <button v-on:click="gotoPlanPage()" class="btn btn-add btn-lg btn-success"><i class="fa fa-key" aria-hidden="true" v-if="!isActive"></i> Unlock</button>
      </sweet-modal>

    </div>

  </div>
</template>

<script>
import Step from '@/components/StepBar'
import router from '@/router'
import WorkingSchedule from '@/components/WorkingSchedule'
import WorkingTimeSlot from '@/components/WorkingTimeSlot'
import WorkingBookingPerSlot from '@/components/WorkingBookingPerSlot'
import WorkingSlotPreview from '@/components/WorkingSlotPreview'
import DoctorMixin from './mixin'
import { SweetModal } from 'sweet-modal-vue'

export default {
  name: 'DoctorEditStep3',
  mixins: [DoctorMixin],
  components: {
    Step,
    WorkingSchedule,
    WorkingTimeSlot,
    WorkingBookingPerSlot,
    WorkingSlotPreview,
    SweetModal
  },
  data () {
    return {
    /*
     * "id": 1382,
     * "doctor_id": 317,
     * "clinic_id": 18,
     * "week_day": "sat",
     * "time_from": "9:00:00",
     * "time_to": "18:00:00",
     * "time_slots": 30,
     * "booking_per_slot": 4
     * */
      doctor: {},
      /*
       * { clinic_id: [ schedules ] }
       */
      schedules_by_clinics: {},
      slotData: {},
      currentClinic: null
    }
  },
  computed: {
    isActive () {
      return this.$guser.user.clinic && this.$guser.user.clinic.active === 1
    }
  },
  methods: {
    back () {
      router.go(-1)
    },
    saveAndContinue () {
      let routeData = { path: this.next_uri(3), query: {action: this.$route.query.action} }
      this.$http.put(this.doctor_uri,
        // data
        {
          appointment_active: this.doctor.appointment_active,
          schedules: this.doctor.schedules
        },
        // options
        {
          credentials: true,
          headers: { 'content-type': 'application/json' }
        }).then(res => {
          if (res.body.status === 'success') {
            this.$toastr.success(this.$t('action_message.save_success'))
            router.push(routeData)
          }
        })
    },
    updateSchedules (clinicId, schedule) {
      // remove all schedule with the clinic id
      this.doctor.schedules = this.doctor.schedules.filter(s => !(s.clinic_id === clinicId))

      // add new schedule for the clinic
      this.doctor.schedules = this.doctor.schedules.concat(schedule)
    },
    updateTimeSlots (clinicId, timeSlots) {
      this.slotData = Object.assign({}, this.slotData, {
        [clinicId]: {
          time_slots: timeSlots,
          booking_per_slot: this.slotData[clinicId].booking_per_slot
        }
      })
    },
    updateBookingPerSlot (clinicId, booking) {
      this.slotData = Object.assign({}, this.slotData, {
        [clinicId]: {
          booking_per_slot: booking,
          time_slots: this.slotData[clinicId].time_slots
        }
      })
    },
    async deleteDoctor () {
      if (await this.$confirm(this.$t('action_message.are_you_sure'))) {
        this.$http.delete(this.$APP_CONFIG.api.admin.doctors_id(this.doctor.id)).then(res => {
          if (res.body) {
            router.push({path: '/clinic/doctors'})
          }
        })
      }
    },
    shouldView (clinicId) {
      return !this.$guser.isClinic() || (this.$guser.isClinic() && clinicId === this.currentClinic)
    },
    checkFeature (name) {
      if (!this.$guser.isPremiumAccount()) {
        this.$refs.lockModal.open()
        return false
      }
      return true
    },
    gotoPlanPage () {
      this.$refs.lockModal.close()
      if (this.$guser.isClinic()) {
        router.push({'path': '/package', query: {'type': 'clinic'}})
      } else if (this.$guser.isDoctor()) {
        router.push({'path': '/package', query: {'type': 'doctor'}})
      }
    }
  },
  // hooks
  created () {
    var self = this

    if (this.$guser.isClinic()) {
      this.$http.get(this.$APP_CONFIG.api.admin.clinicme(), { credentials: true }).then(res => {
        self.currentClinic = res.body.data.id
      }, errorResponse => {
        console.error(errorResponse)
      })
    }

    this.$http.get(this.doctor_uri).then(res => {
      self.doctor = Object.assign({}, res.body.data)

      // make default for schedules in case empty
      self.doctor.clinics.forEach(c => {
        self.schedules_by_clinics[c.id] = []
        self.slotData[c.id] = {time_slots: 30, booking_per_slot: 4}
      })
      // group schedules by clinics
      self.doctor.schedules.forEach(s => {
        self.schedules_by_clinics[s.clinic_id] = self.schedules_by_clinics[s.clinic_id] || []
        self.schedules_by_clinics[s.clinic_id].push(s)
        if (self.schedules_by_clinics[s.clinic_id].length > 0) {
          self.slotData[s.clinic_id] = Object.assign({}, {
            time_slots: self.schedules_by_clinics[s.clinic_id][0].time_slots,
            booking_per_slot: self.schedules_by_clinics[s.clinic_id][0].booking_per_slot
          })
        }
      })
    }, errorResponse => {
      console.error(errorResponse)
    })
  }
}

</script>

<style lang="scss">
@import "../../../assets/base_container";
.step-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.step-container{
  h6{
    color: #5e5e5e;
    margin-bottom: 12px;
    font-size: 1.2rem;
  }
  .step-body{
    background-color: #fff;
    padding-top: 10px;
  }

  .online-appointment{
    font-size: 20px;
  }
  
  .switch{
    vertical-align: middle;
  }

  .online-appointment.disable{
    .switch-label{
      background-color: #a2a0a0 !important;
      border-color: #a2a0a0;
    }
    .switch-name{
      color: #a2a0a0;
    }
    .switch-handle{
      border-color: #a2a0a0;
    }
  }
}
.form-divider{
  height: 1px;
  border: 1px dashed #eee;
  margin: 10px 0;
}
.gender-select{
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  .form-check{
    margin-bottom: 0px;
  }
  .form-check-inline + .form-check-inline{
    margin-left: 2.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// Schedules.vue?d77990ca